export default __webpack_public_path__ + "static/media/icon-geolocalisation.a16f5e33.svg";